import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import React, { useState } from "react";

const mockdata = [
  {
    region: "APAC",
    value: [
      { type: "Actual", "A&M NON-WORKING": 2, FACILITIES: 1, INGREDIENTS: 1, COMMODITIES: 3, LOGISTICS: 3 },
      { type: "Plan", "BUSINESS SERVICES": 1, COMMODITIES: 2, "FRUITS & VEGETABLES": 1, INGREDIENTS: 3, LOGISTICS: 4 },
      { type: "Forecast", "BUSINESS SERVICES": 3, CAPITAL: 7, COMMODITIES: 4, FACILITIES: 8, LOGISTICS: 2 },
    ],
  },
  {
    region: "AMESA",
    value: [
      { type: "Actual", "A&M NON-WORKING": 2, FACILITIES: 1, INGREDIENTS: 1, COMMODITIES: 4 },
      { type: "Plan", "BUSINESS SERVICES": 1, COMMODITIES: 2, "FRUITS & VEGETABLES": 1, INGREDIENTS: 3 },
      { type: "Forecast", "BUSINESS SERVICES": 3, CAPITAL: 2, COMMODITIES: 4, FACILITIES: 8 },
    ],
  },
  {
    region: "PBNA",
    value: [
      { type: "Actual", "A&M NON-WORKING": 2, FACILITIES: 1, INGREDIENTS: 1, COMMODITIES: 1 },
      { type: "Plan", "BUSINESS SERVICES": 1, COMMODITIES: 2, "FRUITS & VEGETABLES": 1, INGREDIENTS: 3 },
      { type: "Forecast", "BUSINESS SERVICES": 3, CAPITAL: 23, COMMODITIES: 4, FACILITIES: 9 },
    ],
  },
];

const categoryColors = {
  "PACKAGING": { Actual: "#0078A7", Plan: "#B05788", Forecast: "#FF891C" },
  "A&M NON-WORKING": { Actual: "#33ABDA", Plan: "#D09AB8", Forecast: "#FFD0A4" },
  "SWEETENERS": { Actual: "#99D5ED", Plan: "#EFDDE7", Forecast: "#FFE7D2" },
  "FACILITIES": { Actual: "#005F8A", Plan: "#8E3A5A", Forecast: "#E66A00" },
  "BUSINESS SERVICES": { Actual: "#0088C2", Plan: "#C072A1", Forecast: "#FF9800" },
  "FRUITS & VEGETABLES": { Actual: "#66C2E4", Plan: "#E6A5C4", Forecast: "#FFA500" },
  "MAINT, REPAIRS, OPS": { Actual: "#004D73", Plan: "#F4C6D6", Forecast: "#FFB347" },
  "COMMODITIES": { Actual: "#1E90FF", Plan: "#FFB6C1", Forecast: "#FFC87C" },
  "INGREDIENTS": { Actual: "#5B9BD5", Plan: "#DB7093", Forecast: "#D2691E" },
  "CAPITAL": { Actual: "#87CEEB", Plan: "#FADADD", Forecast: "#E89C49" },
  "SUPPLY CHAIN": { Actual: "#4682B4", Plan: "#D87093", Forecast: "#F4A460" },
  "BU 1": { Actual: "#2A7FBC", Plan: "#FF91A4", Forecast: "#FF7F50" },
  "BU 2": { Actual: "#B0E0E6", Plan: "#FFC0CB", Forecast: "#FFA07A" },
  "LOGISTICS": { Actual: "#006994", Plan: "#CC7793", Forecast: "#FFA64D" }
};


// Function to process data correctly

const processChartData = (data) => {
  return data && data.map((entry) => {
    const region = entry.region;
    const formattedValues = {};
    const totals = { actual: 0, planned: 0, forecast: 0 };

    entry?.value?.forEach((category) => {
      Object.keys(category).forEach((key) => {
        if (key !== "type" && category[key] !== undefined) {
          const stackKey = `${category.type.toLowerCase()}_${key}`;
          // const value = parseFloat(Number(category[key]).toFixed(2)) || 0;
          const value = parseFloat(Number(category[key])) || 0;
          // Store the value, including negatives
          formattedValues[stackKey] = value;

          // Accumulate totals
          if(value>=0) {
            totals[category.type.toLowerCase()] = (totals[category.type.toLowerCase()] || 0) + value;
          }
        }
      });
    });

    return { region, ...formattedValues, ...totals };
  });
};

const VerticalStackedChart = ({ data, buColorMap }) => {
  // console.log(data, buColorMap);

  const [hoveredBar, setHoveredBar] = useState(null);

  const handleMouseEnter = (dataKey, index, value) => {
    setHoveredBar({ dataKey, index, value });
  };
  const handleMouseLeave = () => {
    setHoveredBar(null);
  };

  const chartData = processChartData(data);
  // console.log(buColorMap)
  // console.log(chartData)
  // if (chartData?.[0]) {
  //   chartData[0]["planned_NORTH AMERICA"] = -5.3;
  // }
  // console.log(chartData)
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      // Filter out zero and null values to show only hovered segment values
      const filteredData = payload.filter(item => item.value !== 0 && item.value !== null && item.name === hoveredBar?.dataKey);
      if (filteredData.length > 0) {

        return (
          <div style={{ backgroundColor: "white", padding: "5px", border: "1px solid #ccc", borderRadius: "10px", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", }}>
            {filteredData.map((data, index) => (
              <p key={index} style={{ color: data.fill, margin: 0 }}>
                {`${(data.name).replace("_", " ").replace("forecast", "Forecast").replace("planned", "YTD Plan").replace("actual", "Actual")}: ${(data.value).toFixed(2)}`}
              </p>
            ))}
          </div>
        );
      } else {
        return null;
      }
    }
    return null;
  };
  const getStackTotalForPositives = (data, type) => {
    // console.log("Raw Data:", data, type);
    // console.log("All Available Keys:", Object.keys(data));
    const normalizedData = {};
    Object.keys(data).forEach((k) => {
        const normalizedKey = k.replace(/\u00A0/g, " ").trim();
        normalizedData[normalizedKey] = data[k];
    });
    
    //console.log("All Normalized Keys:", Object.keys(normalizedData));
    return Object.keys(buColorMap).reduce((total, category) => {
      const key = `${type}_${category}`.replace(/\u00A0/g, " ").trim();;
      // const value = data[key] || 0;
      const value = normalizedData[key] || 0;
      //console.log("--"+data["planned_UAE AMESA HQ"]+"--") // HERE
      // let exactKey = Object.keys(data).find(k => k.trim() === key.trim());
      // console.log("Generated Key:", key, " -> Found Key:", exactKey, " -> Value:", data[exactKey]);
      // console.log("Generated Key:", key, " -> Value:", normalizedData[key]);

     // console.log(key, value)
      // return total + (value > 0 ? value : 0);
      return total + (value);
    }, 0);
  };
  
  // const getStackTotalForNegatives = (data, type) => {
  //   const normalizedData = {};
  //   Object.keys(data).forEach((k) => {
  //       const normalizedKey = k.replace(/\u00A0/g, " ").trim();
  //       normalizedData[normalizedKey] = data[k];
  //   });
  //   return Object.keys(buColorMap).reduce((total, category) => {
  //     const key = `${type}_${category}`.replace(/\u00A0/g, " ").trim();;
  //     // const value = data[key] || 0;
  //     const value = normalizedData[key] || 0;
  //     return total + (value < 0 ? value : 0);
  //   }, 0);
  // };
  
  const normalizeDataArray = (dataArray) => {
    return dataArray.map(obj => {
        let normalizedObj = {};
        Object.keys(obj).forEach(key => {
            const normalizedKey = key.replace(/\u00A0/g, " ").trim();
            normalizedObj[normalizedKey] = obj[key]; // Preserve the value
        });
        return normalizedObj;
    });
};

const normalizedData = normalizeDataArray(chartData);
const chartHeight = normalizedData.length<4 ? 400 : normalizedData.length * 110;
  return (
    <div style={{ width: "100%", maxHeight: "400px", overflowY: "auto" }}>
    <div style={{ width: "100%", height: chartHeight }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          layout="vertical"
          data={normalizedData}
          margin={{ top: 20, right: 60, left: 25, bottom: 20 }}
          stackOffset="sign"
        >
          <CartesianGrid horizontal={false} vertical stroke="#DFDFDF" />
          <XAxis type="number" axisLine={false} tickLine={false} />
          <YAxis type="category" dataKey="region" tickLine={false} />
          <Tooltip content={<CustomTooltip />} cursor={false} />
          

          {Object.keys(buColorMap).flatMap((category, index, array) =>
            ["actual", "planned"].map((type) => { // ["actual", "planned", "forecast"]
              const key = `${type}_${category}`.replace(/\u00A0/g, " ").trim();
              // console.log("VKEy", key)
              const isTopBar = index === array.length - 1;
              return (
                <Bar key={key} dataKey={key} stackId={type} fill={buColorMap[category][type]} barSize={24} 
                onMouseEnter={(e, index) => handleMouseEnter(key, index, e[key])}
                onMouseLeave={handleMouseLeave}>
                  {/* {isTopBar && (
                    <LabelList
                      dataKey={type}
                      position="right"
                      fill="#3A3A3A"
                      fontWeight="bold"
                      style={{ fontWeight: 900, color: "#3A3A3A" }}
                      formatter={(value) => value.toFixed(2)}
                    />
                  )} */}
                   {isTopBar && (
                  <LabelList
                    content={(props) => {
                      const { x, y, width } = props;
                      const total = getStackTotalForPositives(chartData[props.index], type);
                      // const totalNegative = getStackTotalForNegatives(chartData[props.index], type);
                     // const positionX = total < 0 ? x - 20 : x + width + 10;
                     const positionX = x + width + 10;;
                     const positionY = y+12;
                      return (
                        <text
                          x={positionX}
                          y={positionY}
                          fill="#000"
                          fontSize={14}
                          fontWeight="bold"
                          textAnchor={total < 0 ? "end" : "start"}
                          dominantBaseline="central"
                        >
                          {total.toFixed(2)} 
                          {/* {total} */}
                          {/* {  totalNegative < 0 && 
                                  <tspan fill={"red"}>
                                    ({totalNegative.toFixed(2)})
                                  </tspan>
                          } */}
                          
                        </text>
                      );
                    }}
                  />
                )}
                </Bar>  
              );
            })
          )}
        </BarChart>
      </ResponsiveContainer>
    </div>
    </div>
  );
};

export default VerticalStackedChart;
